import financeables from '@/store/debug/financeables'

export default {
  namespaced: true,
  modules: {
    financeables
  }
}
